import { cn } from '@/lib/utils'

interface LogoProps {
  className?: string
  showText?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export default function Logo({ className, showText = true, size = 'md' }: LogoProps) {
  const sizes = {
    sm: { icon: 'w-6 h-6', text: 'text-base' },
    md: { icon: 'w-8 h-8', text: 'text-lg' },
    lg: { icon: 'w-12 h-12', text: 'text-2xl' },
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {/* Logo Icon */}
      <div className={cn('relative', sizes[size].icon)}>
        <svg
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          {/* Background circle with gradient */}
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#6366f1" />
              <stop offset="100%" stopColor="#818cf8" />
            </linearGradient>
            <linearGradient id="screenGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#22d3ee" />
              <stop offset="100%" stopColor="#6366f1" />
            </linearGradient>
          </defs>

          {/* Main circle background */}
          <circle cx="20" cy="20" r="18" fill="url(#logoGradient)" opacity="0.15" />
          <circle cx="20" cy="20" r="18" stroke="url(#logoGradient)" strokeWidth="2" fill="none" />

          {/* Monitor/Screen shape */}
          <rect x="10" y="11" width="20" height="14" rx="2" fill="url(#screenGradient)" opacity="0.9" />

          {/* Screen inner glow */}
          <rect x="12" y="13" width="16" height="10" rx="1" fill="#0d0d12" opacity="0.6" />

          {/* Connection lines representing remote access */}
          <path
            d="M16 17L19 20L24 15"
            stroke="#22c55e"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {/* Monitor stand */}
          <path
            d="M17 25H23L22 28H18L17 25Z"
            fill="url(#logoGradient)"
          />

          {/* Base */}
          <rect x="15" y="28" width="10" height="2" rx="1" fill="url(#logoGradient)" />

          {/* Connection dots */}
          <circle cx="8" cy="20" r="2" fill="#6366f1" />
          <circle cx="32" cy="20" r="2" fill="#6366f1" />

          {/* Connection lines */}
          <path d="M10 20H10" stroke="#6366f1" strokeWidth="1" strokeDasharray="2 2" />
          <path d="M30 20H30" stroke="#6366f1" strokeWidth="1" strokeDasharray="2 2" />
        </svg>
      </div>

      {/* Logo Text */}
      {showText && (
        <div className="flex flex-col">
          <span className={cn('font-bold text-sc-text-primary leading-tight', sizes[size].text)}>
            Sim Coaches
          </span>
          <span className="text-xs text-sc-primary font-medium -mt-0.5 tracking-[0.18em]">
            PITSTOP
          </span>
        </div>
      )}
    </div>
  )
}
